import initialState from "./initialState";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

function officeViewReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_CALLS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingCallHistory: true };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_CALLS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingCallHistory: false, call_history: action.data };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_CALLS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingCallHistory: false };

        case getNamedAction(ACTION_NAMES.CALL_HISTORY_ACTIVE, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingActiveCalls: true };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_ACTIVE, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingActiveCalls: false, activeCalls: action.data };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_ACTIVE, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingActiveCalls: false };

        case getNamedAction(ACTION_NAMES.CALL_HISTORY_RECENT, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingRecentCalls: true };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_RECENT, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingRecentCalls: false, recent_calls: action.data };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_RECENT, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingRecentCalls: false };

        case getNamedAction(ACTION_NAMES.CALL_HISTORY_RECENT, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingRecentCall: true };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_RECENT, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, isReadingRecentCall: false, recent_call: action.data };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_RECENT, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingRecentCall: false };

        case getNamedAction(ACTION_NAMES.CALL_HISTORY_CALL_RESULT, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isUpdatingCallResults: true };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_CALL_RESULT, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isUpdatingCallResults: false };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_CALL_RESULT, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isUpdatingCallResults: false };


        case getNamedAction(ACTION_NAMES.CALL_HISTORY_UPCOMING_CALLS, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingUpcomingCalls: true, upcomingCalls: [], upcomingCallsCount: 0 };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_UPCOMING_CALLS, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingUpcomingCalls: false, upcomingCalls: action.data?.data || [], upcomingCallsCount: action.data.count };
        case getNamedAction(ACTION_NAMES.CALL_HISTORY_UPCOMING_CALLS, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingUpcomingCalls: false, upcomingCalls: [], upcomingCallsCount: 0 };
            
        case getNamedAction(
            ACTION_NAMES.CALL_HISTORY_DETAILS,
            CRUD_ACTION_TYPES.READ_ONE_REQUEST
        ):
            return { ...state, isReadingCallHistoryDetails: true };
        case getNamedAction(
            ACTION_NAMES.CALL_HISTORY_DETAILS,
            CRUD_ACTION_TYPES.READ_ONE_SUCCESS
        ):
            return {
                ...state,
                isReadingCallHistoryDetails: false,
                call_history_details: action.data,
            };
        case getNamedAction(
            ACTION_NAMES.CALL_HISTORY_DETAILS,
            CRUD_ACTION_TYPES.READ_ONE_FAILURE
        ):
            return { ...state, isReadingCallHistoryDetails: false };

        case "REMOVE_RECENT_CALL":
            return { ...state, isReadingRecentCall: false, recent_call: null };

        case 'CALL_HISTORY_MARK_CALL':
            {
                const call_history = state.call_history.slice(0);
                const callToMark = call_history.find(call => call.id === action.id);
                callToMark.isMarked = !callToMark.isMarked;
                return { ...state, call_history };
            }
        case 'CALL_HISTORY_MARK_ALL':
            {
                const call_history = state.call_history.slice(0);
                const allMarked = !state.allMarked;
                call_history.forEach(call => { call.isMarked = allMarked });
                return { ...state, call_history, allMarked };
            }
        default:
            return state;
    }
}


export default officeViewReducer;
